<template>
  <c-source-form
    :columns="columns"
    :data="data"
    @submit="handleCreate"
  />
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class AftersalesNew extends Vue {

  data = {}

  get columns() {
    return createColumns();
  }

  async handleCreate() {
  }
}
</script>
